import { render, staticRenderFns } from "./marketplace.vue?vue&type=template&id=42be738e&scoped=true"
import script from "./marketplace.vue?vue&type=script&lang=js"
export * from "./marketplace.vue?vue&type=script&lang=js"
import style0 from "./marketplace.vue?vue&type=style&index=0&id=42be738e&prod&scoped=true&lang=css"
import style1 from "./marketplace.vue?vue&type=style&index=1&id=42be738e&prod&lang=css"
import style2 from "./marketplace.vue?vue&type=style&index=2&id=42be738e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42be738e",
  null
  
)

export default component.exports